export const LIST_VIEW =  'LIST_VIEW';
export const GRID_VIEW = 'GRID_VIEW';
export const INFLUENCER_TAB = 'INFLUENCER_TAB';
export const COLLECTIVE_TAB = 'COLLECTIVE_TAB';



/** WEBPACK FOOTER **
 ** ./constants/viewTypes.js
 **/